import SalesManagementDXJH from './SalesManagementDXJH.vue'
export default SalesManagementDXJH


// WEBPACK FOOTER //
// ./src/pages/salesManagement/dxjh/index.js